module.exports = __webpack_public_path__ + "static/media/how_it_works.a4be95ee.jpg";